import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const PaymentFailurePage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 text-center">
          <h1 className="text-xl font-semibold text-gray-900">
            {t('checkout.failureTitle')}
          </h1>
          <p className="mt-3 text-sm text-gray-600">
            {t('checkout.failureMessage')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailurePage;
